<template>
  <form data-vv-scope="data-group">
    <div class="row mb-5">
      <div class="col-md-6 mt-3">
        <vs-input
          class="w-100"
          label="Código"
          maxlength="40"
          v-model="editGroup.codigo"
          name="groupCode"
          :danger="errors.has('data-group.groupCode')"
          :danger-text="errors.first('data-group.groupCode')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-6 mt-3">
        <vs-input
          class="w-100"
          label="Nombre de Grupo"
          maxlength="250"
          v-model="editGroup.nombre"
          name="groupName"
          :danger="errors.has('data-group.groupName')"
          :danger-text="errors.first('data-group.groupName')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-12 mt-3">
        <vs-input
          class="w-100"
          label="Descripción de Grupo"
          maxlength="250"
          name="groupDescription"
          v-model="editGroup.descripcion"
          :danger="errors.has('data-group.groupDescription')"
          :danger-text="errors.first('data-group.groupDescription')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-11 chip-custom" v-if="this.action === 'add'">
        Este grupo será creado como subgrupo de {{editGroup.padreNombre}}
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            type="border"
            @click="saveChanges()"
            icon="save"
          >
            Guardar
          </vs-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ManageGroups',
  props: {
    group: { type: Object, required: true },
    action: { type: String, required: true },
    name: { type: String, required: true }
  },
  data() {
    return {
      editGroup: {
        ...this.group,
      }
    };
  },
  watch: {
    group(newValue) {
      if (Object.keys(newValue).length) {
        this.editGroup = { ...newValue };
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    ...mapActions('Empresas', [
      'updateGroup',
      'createGroup'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-group');
      if (!isValid) {
        return;
      }
      const group = {
        ...this.editGroup
      };

      if (this.action !== 'addParent') {
        group.esDivision = this.editGroup.esDivision === 'Y' ? 'si' : 'no';
      }
      group.esOficina = 'no';

      if (this.action === 'add' || this.action === 'addParent') {
        await this.createGroup({
          empresaId: this.company.id,
          group
        });
      } else {
        await this.updateGroup({
          empresaId: this.company.id,
          group
        });
      }
      this.$emit('close-action');
    }
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-left: 30px;
  color: #ff9900;
  background-color: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
  text-align: center;
}
</style>
